/**
 * Language selector component.
 * @module components/LanguageSelector/LanguageSelector
 */

import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import find from 'lodash/find';
import map from 'lodash/map';
import { useSelector } from 'react-redux';

import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import langmap from '@plone/volto/helpers/LanguageMap/LanguageMap';
import {
  toBackendLang,
  toReactIntlLang,
} from '@plone/volto/helpers/Utils/Utils';

import config from '@plone/volto/registry';

import { Dropdown } from 'semantic-ui-react';
import { Icon } from '@package/icons';

const LanguageSelector = ({ onClickAction, history }) => {
  const currentLang = useSelector((state) => state.intl.locale);
  const translations = useSelector(
    (state) => state.content.data?.['@components']?.translations?.items,
  );

  const { settings } = config;

  const languageOptions = map(settings.supportedLanguages, (lang) => {
    return {
      key: `language-selector-${lang}`,
      value: lang,
      text: langmap[lang].nativeName,
    };
  });

  return settings.isMultilingual ? (
    <Dropdown
      selection
      icon={<Icon icon="TriangleDown" />}
      options={languageOptions}
      value={toBackendLang(currentLang)}
      className="language-select"
      onChange={(event, data) => {
        const translation = find(translations, { language: data.value });

        history.push(
          translation ? flattenToAppURL(translation['@id']) : `/${data.value}`,
        );

        onClickAction();
      }}
    />
  ) : (
    <Helmet>
      <html lang={toReactIntlLang(settings.defaultLanguage)} />
    </Helmet>
  );
};

LanguageSelector.propTypes = {
  onClickAction: PropTypes.func,
};

LanguageSelector.defaultProps = {
  onClickAction: () => {},
};

export default withRouter(LanguageSelector);
